/* eslint-disable default-case */
export default function Reducer(prevState, action){
    switch (action.type) {
        case "SET_LOADING":
            return {
                ...prevState,
                loading: action.loading,
            };
        case "SET_DISPUTESCHAT":
            return {
                ...prevState,
                disputesChat: action.disputesChat,
            };
        case "SET_DISPUTES":
            return {
                ...prevState,
                disputes: action.disputes,
                lastDoc: action.lastDoc,
                isEnd: action.isEnd,
                loading: action.loading,
            };
        case "SET_IS_END":
            return {
                ...prevState,
                isEnd: action.isEnd,
                loading: action.loading,
            };
        case "SET_SELECTED_DISPUTE":
            return {
                ...prevState,
                selectedDispute: action.selectedDispute,
            };
    }
}